var React = require('react');

function GraphInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"12.5","width":"8","height":"10","rx":"1","key":0}),React.createElement("rect",{"x":"10","y":"6.5","width":"8","height":"16","rx":"1","key":1}),React.createElement("rect",{"x":"20","y":"0.5","width":"8","height":"22","rx":"1","key":2}),React.createElement("rect",{"y":"24.5","width":"28","height":"4","rx":"1","key":3})]);
}

GraphInline.defaultProps = {"width":"28","height":"29","viewBox":"0 0 28 29","fill":"none"};

module.exports = GraphInline;

GraphInline.default = GraphInline;
